import useBooking from '../../../../context/useBooking';

const useBookingDetailsDates = () => {
	const { booking } = useBooking();

	const {
		prices: { base_nett_price, total_days, total_discounted_gross_price },
		pick_up_date_time,
		drop_off_date
	} = booking;

	return {
		total_discounted_gross_price,
		pick_up_date_time,
		base_nett_price,
		drop_off_date,
		total_days,
		booking
	};
};

export default useBookingDetailsDates;
